module.exports = __webpack_public_path__ + "img/archive.aaa09675.svg";